export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const REPLACE_PARTIAL_ACCOUNTS = "REPLACE_PARTIAL_ACCOUNTS";
export const PUSH_ACCOUNT = "PUSH_ACCOUNT";
export const SET_TRANSACTION_CHANGED = "SET_TRANSACTION_CHANGED";
export const REMOVE_ACCOUNT = "REMOVE_ACCOUNT";
